@use 'themes/westfield' as *;
@use 'tools/color' as *;
@use 'tools/dirg' as *;

.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: units(25);
}

.homeLink {
  color: color('Black');
}
